import { create, UseBoundStore } from 'zustand';

import _ from 'scbk-services/utils/lodash-extension.ts';

import type { StoreApi } from 'zustand';

interface LegacyContextState {
    context: Record<string, unknown>;
    getLegacyContext: () => Record<string, unknown>;
    resetLegacyContext: () => void;
    setLegacyContext: (context: Record<string, unknown>) => void;
    updateLegacyContext: (header: Record<string, unknown>) => void;
}

let storeInstance: UseBoundStore<StoreApi<LegacyContextState>> | null = null;

const createStore = () =>
    create<LegacyContextState>((set, get) => ({
        context: {},
        getLegacyContext: () => get().context,
        resetLegacyContext: () => set({ context: {} }),
        setLegacyContext: (context: Record<string, unknown>) => set({ context: context }),
        updateLegacyContext: (context: Record<string, unknown>) =>
            set((state) => ({ context: { ...state.context, ...context } })),
    }));

const useLegacyContextStore = (() => {
    if (_.isEmpty(storeInstance)) {
        storeInstance = createStore();
    }

    return storeInstance!;
})();

export { useLegacyContextStore };
